import React from "react";

export default function MessageNotifIcon({ ...rest }) {
    return (
        <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path
                d="M12.8333 4.66667H9.1C7.13982 4.66667 6.15972 4.66667 5.41103 5.04814C4.75247 5.3837 4.21703 5.91913 3.88148 6.5777C3.5 7.32639 3.5 8.30648 3.5 10.2667V16.3333C3.5 17.4183 3.5 17.9608 3.61926 18.4059C3.94289 19.6137 4.88631 20.5571 6.09413 20.8807C6.53922 21 7.0817 21 8.16667 21V23.7248C8.16667 24.3464 8.16667 24.6572 8.2941 24.8169C8.40493 24.9557 8.57298 25.0365 8.75063 25.0363C8.9549 25.0361 9.19762 24.8419 9.68305 24.4536L12.4661 22.2271C13.0346 21.7723 13.3189 21.5449 13.6354 21.3832C13.9162 21.2397 14.2152 21.1349 14.5241 21.0715C14.8723 21 15.2363 21 15.9644 21H17.7333C19.6935 21 20.6736 21 21.4223 20.6185C22.0809 20.283 22.6163 19.7475 22.9519 19.089C23.3333 18.3403 23.3333 17.3602 23.3333 15.4V15.1667M23.4749 4.52513C24.8417 5.89196 24.8417 8.10804 23.4749 9.47487C22.108 10.8417 19.892 10.8417 18.5251 9.47487C17.1583 8.10804 17.1583 5.89196 18.5251 4.52513C19.892 3.15829 22.108 3.15829 23.4749 4.52513Z"
                stroke="#9195A9"
                strokeWidth="2.33"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
